import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "fields", "minField", "maxField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isRepeatable = this.checkboxTarget.checked

    if (isRepeatable) {
      this.fieldsTarget.classList.remove("hidden")
      if (this.hasMinFieldTarget) {
        this.minFieldTarget.disabled = false
      }
      if (this.hasMaxFieldTarget) {
        this.maxFieldTarget.disabled = false
      }
    } else {
      this.fieldsTarget.classList.add("hidden")
      if (this.hasMinFieldTarget) {
        this.minFieldTarget.disabled = true
      }
      if (this.hasMaxFieldTarget) {
        this.maxFieldTarget.disabled = true
      }
    }
  }
}
